import { render, staticRenderFns } from "./HotelMarkupLayout.vue?vue&type=template&id=070192c8"
import script from "./HotelMarkupLayout.vue?vue&type=script&lang=js"
export * from "./HotelMarkupLayout.vue?vue&type=script&lang=js"
import style0 from "./HotelMarkupLayout.vue?vue&type=style&index=0&id=070192c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports